// Project classification model: Category → Subcategory.
// The former "Project Type" is the Category and "Sub-Type" is the Subcategory.
// Design Type / Website Type are folded into Subcategory values.
//
// These code defaults guarantee the canonical categories + the Graphic Design
// deliverables are always available; any project types configured in the DB are
// merged on top (union) so custom types keep working.

// Graphic Design Subcategories — per the approved Graphic Design Deliverables Guide.
export const GRAPHIC_DESIGN_SUBCATEGORIES = [
  "Logo Design",
  "Stationery Design",
  "Brand Kit / Media Kit",
  "Icon Set",
  "Flyer",
  "Brochure",
  "Banner / Poster",
  "Business Card",
  "Presentation / Pitch Deck",
  "Label Design",
  "Packaging Design",
  "Amazon A+ Content",
  "Product Listing Images",
  "Infographics",
  "Website UI Graphics",
  "Social Media Graphics",
  "Email Graphics",
  "Illustrations",
  "Character Art",
  "Merchandise & Apparel Design",
  "Other (Specify)",
];

export interface CategoryDef {
  name: string;
  subcategories: string[];
}

export const DEFAULT_CATEGORIES: CategoryDef[] = [
  { name: "Graphic Design", subcategories: GRAPHIC_DESIGN_SUBCATEGORIES },
  { name: "Website", subcategories: ["Business Website", "E-commerce Store", "Landing Page", "Web Application", "WordPress", "Shopify", "Custom Development", "Other (Specify)"] },
  { name: "Amazon & Ecommerce", subcategories: ["Store Setup", "Listing Optimization", "PPC / Advertising", "A+ Content", "Storefront Design", "Account Management", "Other (Specify)"] },
  { name: "Mobile App", subcategories: ["iOS App", "Android App", "Cross-Platform App", "UI/UX Design", "App Maintenance", "Other (Specify)"] },
  { name: "Video Animation", subcategories: ["Explainer Video", "2D Animation", "3D Animation", "Motion Graphics", "Video Editing", "Whiteboard Animation", "Other (Specify)"] },
  { name: "Marketing", subcategories: ["SEO", "Social Media Marketing", "Content Marketing", "Email Marketing", "PPC Campaigns", "Brand Strategy", "Other (Specify)"] },
];

export const DEFAULT_CATEGORY_NAMES = DEFAULT_CATEGORIES.map((c) => c.name);

// Union of DB-configured category names with the canonical defaults (dedup,
// preserving DB order first).
export const mergeCategoryNames = (dbNames: string[] = []): string[] => {
  const out = [...dbNames];
  for (const n of DEFAULT_CATEGORY_NAMES) if (!out.includes(n)) out.push(n);
  return out;
};

// Subcategories for a category: DB-configured sub-types first, then the code
// defaults for that category (dedup).
export const subcategoriesFor = (categoryName: string, dbSubTypes: string[] = []): string[] => {
  const def = DEFAULT_CATEGORIES.find((c) => c.name === categoryName)?.subcategories || [];
  const out = [...dbSubTypes];
  for (const s of def) if (!out.includes(s)) out.push(s);
  return out;
};
